const ServiceDetailPage = () => {
  return (
    <div className="container-custom section-padding">
      <h1 className="text-3xl font-bold text-center mb-8">Service Details</h1>
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <p className="text-gray-600">Service details page coming soon...</p>
      </div>
    </div>
  )
}

export default ServiceDetailPage
